module.exports = __webpack_public_path__ + "media/src/images/course_default-d107a3131386b80d23a1dafb5703d203.png";